import { Layout } from "antd";
import { Content, Footer } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import React, { useContext } from "react";
import { MemberContext } from "../context/MemberProvider.tsx";
import { hexToRgba } from "../utils/useColor";

const MemberLayout: React.FC = () => {
  const { memberData } = useContext(MemberContext);

  if (memberData && memberData.foreground_color) {
    document.documentElement.style.setProperty(
      "--app-foreground-color",
      memberData.foreground_color,
    );
    document.documentElement.style.setProperty(
      "--app-lighten-foreground-color",
      hexToRgba(memberData.foreground_color, 0.25),
    );
  }
  if (memberData && memberData.background_color)
    document.documentElement.style.setProperty(
      "--app-background-color",
      memberData.background_color,
    );

  return (
    memberData && (
      <div>
        <Layout
          style={{ backgroundColor: memberData.background_color }}
          className="w-full sm:w-[360px] pb-[83px] mx-auto min-h-screen font-roboto text-title"
        >
          <Content>
            <Outlet />
          </Content>
          <Footer className="mt-auto bg-white fixed bottom-0 w-full sm:w-[360px] h-[83px] px-[15px] pt-[7px]">
            <Navbar couponURL={memberData.coupon_url} hideTabs={memberData.hide_tabs} />
          </Footer>
        </Layout>
      </div>
    )
  );
};
export default MemberLayout;
